angular.module('unergie.main')
    .controller('m023RequestCtrl', ($scope, $state, ApiUser, AlertManager, ReferencesService, BoFeaturesService, FileUploader, ErrorCatcher) => {
        $scope.possible_items = ["loadcurve", "daily_index", "global_daily_energies", "daily_pmax", "billing_measures", "technical_and_contractual_data"]

        $scope.grdContracts = {
            ids: [],
            chosen: undefined,
        }

        $scope.availableFormats = [{label:'JSON'}, {label:'CSV'}]
        // set default format to JSON
        $scope.format = 'JSON'

        // set default dates
        $scope.start_date = moment().subtract(1, 'year').toDate()
        $scope.end_date = moment().toDate()

        $scope.pendingRequest = false

        ReferencesService.getRef('id-grd-contracts', true).then((mapping) => {
            $scope.grdContracts.ids = _.map(mapping, (elem) => ({
                id: elem.id,
                label: elem.id
            }))
            $scope.grdContracts.chosen = $scope.grdContracts.ids.length ? $scope.grdContracts.ids[0].id : undefined
        })

        $scope.prmUploader = new FileUploader({
            alias: 'attachment',
            url: `/api-user/m023/request`,
            formData: [],
            autoUpload: false,
            removeAfterUpload: true,
            method: 'POST',
            onSuccessItem(item, response, status, headers) {
                $scope.handleRequestResult(response)
            },
            onErrorItem(item, response, status, headers) {
                $scope.pendingRequest = false
                const msg = (response && response.error) || response || 'Erreur inconnue'
                AlertManager.error(msg, 15000)
            },
        })

        $scope.performM023Request = () => {
            $scope.pendingRequest = true
            const data = {
                grd_contract: $scope.grdContracts.chosen,
                prms: $scope.prms,
                loadcurve: $scope.loadcurve,
                daily_index: $scope.daily_index,
                global_daily_energies: $scope.global_daily_energies,
                daily_pmax: $scope.daily_pmax,
                billing_measures: $scope.billing_measures,
                technical_and_contractual_data: $scope.technical_and_contractual_data,
                format: $scope.format,
                start_date: moment($scope.start_date).format('YYYY-MM-DD'),
                end_date: moment($scope.end_date).format('YYYY-MM-DD'),
            }
            if ($scope.prmUploader.queue.length) {
                const item = $scope.prmUploader.queue[0]
                item.formData.push(_.pickBy(data, (f) => f != null && f !== ''))
                item.upload()
            } else {
                ApiUser.requestM023(data).$promise.then((results) => {
                    $scope.handleRequestResult(results)
                }).catch((error) => {
                    const msg = (error && error.data && error.data.error) || __guard__(error != null ? error.data : undefined, (x) => x.message) || 'Erreur inconnue'
                    AlertManager.error(msg, 15000)
                    $scope.pendingRequest = false
                })
            }
        }

        $scope.onFormChange = () => {
            $scope.canRequest = $scope.right_to_access && (
                $scope.loadcurve ||
                $scope.daily_index ||
                $scope.global_daily_energies ||
                $scope.daily_pmax ||
                $scope.billing_measures ||
                $scope.technical_and_contractual_data
            )
        }

        $scope.handleRequestResult = (result) => {
            $scope.pendingRequest = false
            $scope.results = result
            let errors = 0
            let success = 0
            result.forEach((item) => {
                $scope.possible_items.forEach((name) => {
                    if (item[name]) {
                        if (item[name].status === "success") {
                            success++
                        } else {
                            errors++
                        }
                    }
                })
            })
            if (!errors) {
                return AlertManager.success('Demande effectuée sans erreur')
            }
            if (success) {
                return AlertManager.error('Demande effectuée avec des erreurs')
            }
            return AlertManager.error('Erreurs dans l\'execution de la demande')
        }

        $scope.results = null
    })
